import { createRoot } from 'react-dom/client';
import RetailerRegistrationApp from './RetailerRegistrationApp';
import VendorRegistrationApp from './VendorRegistrationApp';

// Initialize React app
const container = document.getElementById('registration-root');
if (container) {
    // Read data attributes from container
    const registrationType = container.dataset.registrationType || 'retailer';
    const returnUrl = container.dataset.returnUrl || '/';
    
    console.log('Registration Initialized:', { registrationType, returnUrl });
    
    const root = createRoot(container);
    
    // Render appropriate component based on registration type
    if (registrationType === 'vendor') {
        root.render(<VendorRegistrationApp returnUrl={returnUrl} />);
    } else {
        root.render(<RetailerRegistrationApp returnUrl={returnUrl} />);
    }
}

